import React from "react";
import { Grid, Typography, Box } from "@mui/material";

const NonTabletPriceCalculation = ({ form, repeatproduct, unitRate, boxCount, inventoryCharges, cylinderCharges, gstPercentage }) => {

    const getSubTotalPrice = () => {
        if (repeatproduct) return (unitRate * boxCount)

        return ((unitRate * boxCount) + inventoryCharges + cylinderCharges)
    }
    const getSubtotalWithGST = () => {
        return getSubTotalPrice() + getSubTotalPrice() * gstPercentage / 100
    }
    return (
        <>
            <Grid item lg={6} xs={12} sx={{
                backgroundColor: 'secondary.100', borderRadius: 1, paddingLeft: { lg: 1 }, paddingTop: { xs: 2, lg: 1 },
            }}>
                <Typography variant="h5" color="primary.dark" sx={{ paddingBottom: 1 }}>Price Calculation</Typography>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', paddingRight: 1, paddingBottom: 1 }}>
                    <Grid item lg={12}>
                        <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'white' }}>
                            <Grid item lg={6} xs={12} sx={{ padding: 1, width: '100%' }}>
                                <Typography variant="h6">Unit Rate </Typography>
                                <Typography variant="h6">
                                    <b>{unitRate}</b>/- 
                                </Typography>
                            </Grid>
                            <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                <Typography variant="h6">Price for  {boxCount} '{form}'</Typography>
                                <Typography variant="h6"><b>{unitRate * boxCount}/-</b> </Typography>
                            </Grid>
                            {repeatproduct ? <></> : <>
                                <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                    <Typography variant="h6">Inventory</Typography>
                                    <Typography variant="h5">{inventoryCharges}/-</Typography>
                                </Grid>
                                <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                    <Typography variant="h6">Cylinder</Typography>
                                    <Typography variant="h5">{cylinderCharges}/-</Typography>
                                </Grid>
                            </>}
                        </Grid>

                    </Grid>

                </Grid>
            </Grid>
            <Grid item lg={6} xs={12} sx={{
                backgroundColor: 'secondary.100', borderRadius: 1, paddingLeft: { lg: 1 }, paddingTop: { xs: 2, lg: 1 },
            }}>
                <Typography variant="h5" color="primary.dark" sx={{ paddingBottom: 1 }}>Total Price</Typography>
                <Grid container direction="row" justifyContent="space-between" alignItems="center" sx={{ width: '100%', paddingRight: 1, paddingBottom: 1 }}>
                    <Grid item lg={12}>
                        <Grid container direction="row" sx={{ width: '100%', backgroundColor: 'white' }}>
                            <Grid item lg={6} xs={12} sx={{ padding: 1, width: '100%' }}>
                                <Typography variant="h6">Sub Total</Typography>
                                <Typography variant="h5">{getSubTotalPrice()}</Typography>
                            </Grid>
                            <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                <Typography variant="h6">GST [{gstPercentage}%]</Typography>
                                <Typography variant="h5">{getSubTotalPrice() * gstPercentage / 100}/-</Typography>
                            </Grid>

                            <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                <Typography variant="h6">Total</Typography>
                                <Typography variant="h5">{Math.round(getSubtotalWithGST())}/-</Typography>
                            </Grid>
                            <Grid item lg={6} xs={12} sx={{ padding: 1, backgroundColor: 'white', width: '100%' }}>
                                <Typography variant="h6">Advance</Typography>
                                <Typography variant="h5">{Math.round(getSubtotalWithGST() * 0.25)}/-</Typography>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
            </Grid>
        </>
    );
};

export default NonTabletPriceCalculation;

